var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-center align-items-center" },
            [
              _c("b-spinner", {
                staticClass: "text-center",
                attrs: { variant: "primary" }
              })
            ],
            1
          )
        : !_vm.loading && _vm.holdingTransaccionality
        ? _c(
            "b-card",
            {
              staticClass: "w-100",
              attrs: { "header-tag": "header" },
              scopedSlots: _vm._u([
                {
                  key: "header",
                  fn: function() {
                    return [
                      _c("div", { staticClass: "w-100 d-flex flex-column" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-between" },
                          [
                            _c("h4", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.holdingTransaccionality.razonSocial
                                  ) +
                                  " "
                              ),
                              _c("small", { staticClass: "ml-3" }, [
                                _vm._v(
                                  _vm._s(_vm.holdingTransaccionality.cliente)
                                )
                              ])
                            ]),
                            _c(
                              "div",
                              [
                                _c("vs-icon", {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: "Descargar reporte mensual",
                                      expression: "'Descargar reporte mensual'"
                                    }
                                  ],
                                  staticClass: "cursor-pointer mr-5",
                                  attrs: {
                                    icon: "file_download",
                                    size: "small"
                                  },
                                  on: { click: _vm.downloadMonthlyCSV }
                                }),
                                _c("vs-icon", {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: "Descargar reporte operaciones",
                                      expression:
                                        "'Descargar reporte operaciones'"
                                    }
                                  ],
                                  staticClass: "cursor-pointer",
                                  attrs: {
                                    icon: "file_download",
                                    size: "small"
                                  },
                                  on: { click: _vm.downloadCSV }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _c("hr", { staticClass: "p-0 m-0" }),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-lg-12" },
                  [
                    _c("b-table", {
                      attrs: {
                        "table-class": "text-center",
                        responsive: "",
                        bordered: "",
                        "caption-top": "",
                        items: _vm.transactions,
                        fields: _vm.transactionsFields
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "table-caption",
                          fn: function() {
                            return [_c("h3", [_vm._v("Transacciones")])]
                          },
                          proxy: true
                        },
                        {
                          key: "head(monthlyMb)",
                          fn: function(ref) {
                            var label = ref.label
                            return [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover.left",
                                      value:
                                        "Pueden haber mínimas variaciones en\
              los totales debido al redondeo aplicado.",
                                      expression:
                                        "'Pueden haber mínimas variaciones en\\\n              los totales debido al redondeo aplicado.'",
                                      modifiers: { hover: true, left: true }
                                    }
                                  ],
                                  staticClass: "cursor-default"
                                },
                                [_vm._v(" " + _vm._s(label) + " ")]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-lg-12" },
                  [
                    _c("b-table", {
                      attrs: {
                        "table-class": "text-center",
                        responsive: "",
                        bordered: "",
                        "caption-top": "",
                        items: _vm.storage,
                        fields: _vm.storageFields
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "table-caption",
                          fn: function() {
                            return [_c("h3", [_vm._v("Almacenamiento")])]
                          },
                          proxy: true
                        }
                      ])
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-lg-12" },
                  [
                    _c("b-table", {
                      attrs: {
                        "table-class": "text-center",
                        responsive: "",
                        bordered: "",
                        "caption-top": "",
                        items: _vm.flow,
                        fields: _vm.flowFields
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "table-caption",
                          fn: function() {
                            return [_c("h3", [_vm._v("Aprobaciones")])]
                          },
                          proxy: true
                        }
                      ])
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-lg-4" },
                  [
                    _c("b-table", {
                      attrs: {
                        "table-class": "text-center",
                        responsive: "",
                        bordered: "",
                        "caption-top": "",
                        items: _vm.sign,
                        fields: _vm.signFields
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "table-caption",
                          fn: function() {
                            return [_c("h3", [_vm._v("Firmas")])]
                          },
                          proxy: true
                        }
                      ])
                    })
                  ],
                  1
                ),
                _c("div", { staticClass: "col-lg-12" }, [
                  _c(
                    "div",
                    { staticClass: "text-right" },
                    [
                      _c("vs-button", { on: { click: _vm.goBack } }, [
                        _vm._v("Volver")
                      ])
                    ],
                    1
                  )
                ])
              ])
            ]
          )
        : _c("h4", [
            _vm._v("No hay detalles para esta empresa "),
            _c("div", { staticClass: "col-lg-12" }, [
              _c(
                "div",
                { staticClass: "text-right" },
                [
                  _c("vs-button", { on: { click: _vm.goBack } }, [
                    _vm._v("Volver")
                  ])
                ],
                1
              )
            ])
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }